export interface IDateWithMeta {
  day: string;
  date: Date;
  status: string;
  isToday: boolean;
  isDisabled: boolean;
  isSelected: boolean;
  isCurrentMonth: boolean;
  hasEvent: boolean;
  events?: string[];
  tooltipText?: string;
}

export enum Status {
  ACTIVE = 'active',
  ACTIVE_SELECTED = 'active-selected',
  ACTIVE_SELECTED_RANGE = 'active-selected-range',
  ACTIVE_TODAY = 'active-today',
  ACTIVE_HAS_EVENT = 'active-has-event',

  ACTIVE_TODAY_HAS_EVENT = 'active-today-has-event',
  ACTIVE_TODAY_SELECTED = 'active-today-selected',
  ACTIVE_TODAY_SELECTED_RANGE = 'active-today-selected-range',
  ACTIVE_TODAY_SELECTED_HAS_EVENT = 'active-today-selected-has-event',
  ACTIVE_TODAY_SELECTED_RANGE_HAS_EVENT = 'active-today-selected-range-has-event',
  ACTIVE_SELECTED_HAS_EVENT = 'active-selected-has-event',
  ACTIVE_SELECTED_RANGE_HAS_EVENT = 'active-selected-range-has-event',

  PREV_NEXT_MONTH = 'prev-next-month',
  PREV_NEXT_MONTH_SELECTED = 'prev-next-month-selected',
  PREV_NEXT_MONTH_SELECTED_RANGE = 'prev-next-month-selected-range',
  PREV_NEXT_MONTH_TODAY = 'prev-next-month-today',
  PREV_NEXT_MONTH_HAS_EVENT = 'prev-next-month-has-event',

  PREV_NEXT_MONTH_TODAY_HAS_EVENT = 'prev-next-month-today-has-event',
  PREV_NEXT_MONTH_TODAY_SELECTED = 'prev-next-month-today-selected',
  PREV_NEXT_MONTH_TODAY_SELECTED_RANGE = 'prev-next-month-today-selected-range',
  PREV_NEXT_MONTH_TODAY_SELECTED_HAS_EVENT = 'prev-next-month-today-selected-has-event',
  PREV_NEXT_MONTH_TODAY_SELECTED_RANGE_HAS_EVENT = 'prev-next-month-today-selected-range-has-event',
  PREV_NEXT_MONTH_SELECTED_HAS_EVENT = 'prev-next-month-selected-has-event',
  PREV_NEXT_MONTH_SELECTED_RANGE_HAS_EVENT = 'prev-next-month-selected-range-has-event',

  INACTIVE = 'inactive',
  INACTIVE_SELECTED = 'inactive-selected',
  INACTIVE_SELECTED_RANGE = 'inactive-selected-range',
  INACTIVE_TODAY = 'inactive-today',
  INACTIVE_TODAY_SELECTED = 'inactive-selected',
  INACTIVE_TODAY_SELECTED_RANGE = 'inactive-selected-range',
}

export interface IFilledMonth {
  prevMonth: Date[];
  currMonth: Date[];
  nextMonth: Date[];
}

export enum HEADER_ACTION_HANDLERS {
  PREV_MONTH = 'prevMonth',
  NEXT_MONTH = 'nextMonth',
  YEAR_BUTTON = 'yearButton',
  MONTH_BUTTON = 'monthButton',
  PREV_BUTTON = 'prevButton',
  NEXT_BUTTON = 'nextButton',
}

export interface IDateUnitsInterface {
  day?: string;
  week?: string;
  month?: string;
  year?: string;
  decade?: string;
}

export interface ISelectedRangeLabel {
  from: string;
  to?: string;
}

export interface ISelectedRange {
  start: Date | null;
  end?: Date | null;
}

export interface IDatesTooltip {
  label: string;
  dates?: Date[];
  dateRange?: ISelectedRange;
}

export type labeledDateUnitType = Record<'month' | 'year' | 'day', Record<string, string | number>>;

export type IMenuItem =
  | {
      label: string;
      startDate: Date;
      endDate: Date;
    }
  | {
      label: string;
      valueInDays: number;
      startDate: Date;
    }
  | {
      label: string;
      valueInDays: number;
    };

export interface IHeaderConfig {
  disableNextYear?: boolean;
  disableNextMonth?: boolean;
  disablePrevYear?: boolean;
  disablePrevMonth?: boolean;
  disableYear?: boolean;
  disableMonth?: boolean;
  hideYear?: boolean;
  hideMonth?: boolean;
}

export enum PHX_DATE_FORMAT {
  /** @remarks Ignored when PHX_LOCALE_PROVIDER is injected. */
  'MM/dd/yyyy' = 'MM/dd/yyyy',
  /** @remarks Ignored when PHX_LOCALE_PROVIDER is injected. */
  'MM-dd-yyyy' = 'MM-dd-yyyy',
  /** @remarks Ignored when PHX_LOCALE_PROVIDER is injected. */
  'MMM dd, yyyy' = 'MMM dd, yyyy',
  /** @remarks Ignored when PHX_LOCALE_PROVIDER is injected. */
  'yyyy-MM-dd' = 'yyyy-MM-dd',
  /** @remarks Ignored when PHX_LOCALE_PROVIDER is injected. */
  'dd MMM, yyyy' = 'dd MMM, yyyy',
  /** @remarks Ignored when PHX_LOCALE_PROVIDER is injected. */
  'dd MMM yyyy' = 'dd MMM yyyy',
}

export interface IPhxDateEvent {
  name: string;
  dates: Date[];
}

export type SelectorSize = 'small' | 'medium' | 'large';

export const DATE_INPUT_FIELD = {
  MONTH: 'month',
  DAY: 'day',
  YEAR: 'year',
} as const;

export type PhxDateInputField = 'month' | 'day' | 'year' | null;
export type PhxNonNullDateInputField = Exclude<PhxDateInputField, null>;

export interface PhxDateFormatConfig {
  fieldOrder: [PhxNonNullDateInputField, PhxNonNullDateInputField, PhxNonNullDateInputField];
  separators: [string, string];
  monthDisplay: 'numeric' | 'alpha';
}

export type PhxDateViolationType = 'min' | 'max' | 'range' | 'disabled';
